import { Controller } from "@hotwired/stimulus"
import {debounce} from "../libs/utils";

/**
 * Make forms to submit when a new change is made in one of its inputs
 *
 * @example
 * <form data-controller="autosubmit">
 *   <input />
 * </form>
 */

export default class AutoSubmitController extends Controller {
  static values = {
    formFields: {type: Array, default: []},
    delay: Number,
  }

  initialize() {
    const delay = (this.delayValue === 0) ? 300 : this.delayValue;

    // console.debug("Autosubmit form, delay:",  delay, this.formFieldsValue);
    this.doSubmit = debounce(this.doSubmit.bind(this), delay)

    this.element.addEventListener('input', (e) => {
      if (this.formFieldsValue.length === 0) {
        console.warn("=> Autosubmit", this.formFieldsValue, e.target);
        this.doSubmit();
        return
      }

      if (this.formFieldsValue.includes(e.target.name)) {
        console.warn("=> Autosubmit field found", this.formFieldsValue, e.target);
        this.doSubmit();
      }
    }, false);
  }

  doSubmit() {
    this.element.requestSubmit();
  }
}
